import { STATUS_TRANSITIONS } from "./constants"

export const getStatusUpdateOptions = (currentStatus) => STATUS_TRANSITIONS[currentStatus] || []
